import React from "react";

const Cup = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.333 4.1665H3.33301V9.99984C3.33301 11.8408 4.82539 13.3332 6.66634 13.3332H9.99967C11.8406 13.3332 13.333 11.8408 13.333 9.99984V9.1665M13.333 4.1665V9.1665M13.333 4.1665H14.9997C15.9201 4.1665 16.6663 4.9127 16.6663 5.83317V7.49984C16.6663 8.42031 15.9201 9.1665 14.9997 9.1665H13.333M3.33301 15.8332H14.9997"
        stroke="#00991F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Cup;
